const Form = ({ children, onSubmitHandler }) => {
  return (
    <form onSubmit={onSubmitHandler} className="form" noValidate>
      {/* エンターキーでサブミットしないようにダミーボタン配置 */}
      <button type="submit" disabled className="d-none"></button>
      {children}
    </form>
  );
};
export default Form;
